module.exports = __webpack_public_path__ + "static/media/foodTruck.a3e455eb.svg";